import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetallSmsCampaignListReports } from '../Features/Smscampaignreports/Smscampaignlist';
import { RootState, AppDispatch } from '../Appstore/store';
import { RenderPaginationButtons } from '../Components/Paginations';
import HelpText from '../Components/HelpText';

function SmscampaignReportsList() {
  const [search, setSearch] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const limit = 10;
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path ? 'active' : '';
  const [debouncedSearch, setDebouncedSearch] = useState<string>(search);

  const { smscampaignlistreportdata, info, loading, error } = useSelector((state: RootState) => state.smscampaignlistreports);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 800);

    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    dispatch(GetallSmsCampaignListReports({ search: debouncedSearch, page: currentPage, limit }));
  }, [dispatch, debouncedSearch, currentPage, limit]);

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= (info?.total_page || 1)) {
      setCurrentPage(page);
    }
  };


  const message = location.state?.message;

  if (error) {
    <div>No found data</div>
  }

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4 shadow-sm border rounded">
                <div className="card-header bg-white p-3 d-sm-flex justify-content-sm-between align-items-center">
                  <h2 className="w-100 text-sm-start text-center mb-md-2 mb-3 fs-3">SMS Campaigns List Reports</h2>
                  <div className='d-sm-flex justify-content-between align-items-center mb-md-0 mb-3'>
                    <div className="input-group input-group-sm pe-sm-3 mb-sm-0 mb-3 search-input">
                      <input
                        type="search"
                        className="form-control float-right height-40px shadow-none"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <div className="input-group-append">
                        <button type="submit" className="btn border cursor-pointer-none">
                          <i className="fas fa-search" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <>
                  <div className='table-responsive'>
                    <table className="table table-hover table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th className='ps-3 sr-no'>SR No</th>
                          <th style={{ maxWidth: 200 }}>Name</th>
                          <th className='status text-center'>Status</th>
                          <th className='text-center action'>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={7} height={100}>
                              <div className="text-center" >
                                <div className="loader"></div>
                              </div>
                            </td>
                          </tr>
                        ) : !smscampaignlistreportdata || smscampaignlistreportdata.length === 0 ? (
                          <tr className='border-bottom-0'>
                            <td colSpan={7} height={50}>
                              <div className="text-center" >
                                <p className='mb-0 fs-5 fw-semibold'>No data found</p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          smscampaignlistreportdata?.map((item, index) => (
                            <tr key={item.id}>
                              <td className='ps-3'>{(currentPage - 1) * limit + index + 1}</td>
                              <td>{item.name}</td>
                              <td className={`text-center ${item?.status === 1 ? 'text-warning fw-bold' : item?.status === 2 ? 'text-success fw-bold' : item?.status === 3 ? 'text-danger fw-bold' : item?.status === 4 ? 'text-success fw-bold' : item?.status === 5 ? 'text-danger fw-bold' : 'text-danger fw-bold'}`}>
                                {item.status === 1 ? 'Pending' : item.status === 2 ? 'Running' : item.status === 3 ? 'Stopped' : item.status === 4 ? 'Completed' : item.status === 5 ? 'Canceled' : 'Failed'}
                              </td>
                              <td className='text-center'>
                                <Link to={`/admin/sms-campaign-reports/${item.id}`}>
                                  <button className='ms-1 bg-transparent border-0 text-success fs-5'>
                                    <i data-tooltip-id={"View_Btn_" + index} className="fa-solid fa-eye"></i>
                                    <HelpText id={"View_Btn_" + index} content="View Report" />
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>

                  {!smscampaignlistreportdata || smscampaignlistreportdata.length === 0 ? (
                    <div></div>
                  ) : (
                    <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                      <RenderPaginationButtons
                        info={info}
                        currentPage={currentPage}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  )}
                </>
              </div>
            </div>
          </section>
        </div>
      </div>

    </>
  )
}

export default SmscampaignReportsList
